module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/150-bolivia-2d6f1fa1d52276f3cc8f7cb08d79a4d1.svg";